<div class="gaze-page-container" [ngClass]="policyType">
  <!-- Gaze Header -->
  <header class="gaze-header">
    <div class="back-btn-container">
      <button class="back-btn" (click)="OnClickClose()" aria-label="Go back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="#2d6a70" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="gaze-logo-wrapper">
      <h1 class="gaze-logo">Gaze</h1>
      <span class="gaze-sublogo">
         <span class="by-text">by</span> WindowSwap</span>
    </div>
    <div class="gaze-page-subtitle">{{ pageTitle }}</div>
  </header>

  <!-- Gaze Content Body -->
  <main class="gaze-content-body">
    <div class="gaze-content-container">
      <div class="gaze-policy-content-wrapper">
        <div *ngIf="isLoaderActive" class="spinner-inline-container">
          <p class="loading-text">Loading...</p>
        </div>
        <div *ngIf="!isLoaderActive" class="gaze-policy-content animate__animated animate__fadeIn" [innerHTML]="safeHtmlContent"></div>
      </div>

      <!-- Standard Gaze Footer -->
      <footer *ngIf="!isLoaderActive" class="gaze-footer">
        <p class="footer-company">{{ constants.GAZE_FOOTER_CONTENT.footer.company }}</p>
        <p class="footer-copyright">{{ constants.GAZE_FOOTER_CONTENT.footer.copyright }}</p>
      </footer>
    </div>
  </main>
</div>
